import React, { useState, useEffect } from 'react';
import { FaHistory, FaUser, FaDesktop, FaGlobe } from 'react-icons/fa';
import API_BASE_URL from '../../config/api';

const ActivityLog = () => {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchLogs = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/admin/get_activity_log.php`);
      const data = await response.json();
      if (data.status === 'success') {
        setLogs(data.data);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLogs();
  }, []);

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h2 className="text-xl font-bold text-slate-800 flex items-center gap-2">
          <FaHistory className="text-orange-500" /> System Activity History
        </h2>
        <button onClick={fetchLogs} className="text-xs font-bold text-orange-500 hover:underline uppercase tracking-widest">Refresh Logs</button>
      </div>

      <div className="bg-white rounded-3xl border border-slate-100 shadow-sm overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-left border-collapse">
            <thead>
              <tr className="bg-slate-50 border-b border-slate-100 text-[10px] font-black text-slate-400 uppercase tracking-widest">
                <th className="px-6 py-4">Timestamp</th>
                <th className="px-6 py-4">User / Role</th>
                <th className="px-6 py-4">Action Taken</th>
                <th className="px-6 py-4">IP & Device Info</th>
                <th className="px-6 py-4">Details</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-50">
              {loading ? (
                <tr>
                  <td colSpan="5" className="px-6 py-12 text-center">
                    <div className="w-8 h-8 border-4 border-orange-500 border-t-transparent rounded-full animate-spin mx-auto"></div>
                  </td>
                </tr>
              ) : logs.length === 0 ? (
                <tr>
                  <td colSpan="5" className="px-6 py-12 text-center text-slate-400 font-medium italic">No activity logs found.</td>
                </tr>
              ) : logs.map((log) => (
                <tr key={log.id} className="hover:bg-slate-50/50 transition-colors">
                  <td className="px-6 py-4 whitespace-nowrap">
                    <div className="flex flex-col">
                      <span className="text-xs font-bold text-slate-700">{new Date(log.created_at).toLocaleDateString()}</span>
                      <span className="text-[10px] text-slate-400 font-bold">{new Date(log.created_at).toLocaleTimeString()}</span>
                    </div>
                  </td>
                  <td className="px-6 py-4">
                    <div className="flex items-center gap-3">
                      <div className={`w-8 h-8 rounded-full flex items-center justify-center text-xs font-bold ${log.role === 'admin' ? 'bg-orange-100 text-orange-600' : 'bg-blue-100 text-blue-600'}`}>
                        {log.full_name?.charAt(0) || 'U'}
                      </div>
                      <div>
                        <p className="font-bold text-slate-800 text-sm">
                          {log.full_name || 'Guest'} 
                          <span className="ml-2 text-[10px] text-slate-400 font-normal">#{log.user_id?.toString().padStart(4, '0')}</span>
                        </p>
                        <p className="text-[9px] font-black uppercase text-slate-400 tracking-tighter">{log.role || 'Guest'}</p>
                      </div>
                    </div>
                  </td>
                  <td className="px-6 py-4">
                    <span className="px-3 py-1 bg-slate-100 text-slate-600 rounded-full text-[10px] font-black uppercase tracking-widest">
                      {log.action}
                    </span>
                  </td>
                  <td className="px-6 py-4">
                    <div className="space-y-1">
                      <div className="flex items-center gap-2 text-[10px] font-bold text-slate-500">
                        <FaGlobe size={10} className="text-slate-300" /> {log.ip_address}
                      </div>
                      <div className="flex items-center gap-2 text-[10px] font-bold text-slate-400 truncate max-w-[150px]" title={log.user_agent}>
                        <FaDesktop size={10} className="text-slate-300" /> {log.user_agent}
                      </div>
                    </div>
                  </td>
                  <td className="px-6 py-4">
                    <p className="text-xs text-slate-600 italic font-medium">{log.details}</p>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default ActivityLog;
